import { render } from "./OnlineStatus.vue?vue&type=template&id=faf3c9f2"
import script from "./OnlineStatus.vue?vue&type=script&lang=js"
export * from "./OnlineStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__